import { RX_EMAIL, RX_PHONE } from '@zillow/validation-regexes';
import type { LocalDate } from '@zg-rentals/ts-renter-info-client';
import { isLocalDateInPast } from './dateUtils';

export const MOVE_IN_DATE_PAST_ERROR = 'Please enter a future date';

export const validateMoveInDate = (date: LocalDate | undefined): string | null =>
  date && isLocalDateInPast(date) ? MOVE_IN_DATE_PAST_ERROR : null;

export const validateEmail = (value?: string): string | null => {
  if (!value || value.trim() === '') {
    return 'Email is required';
  }
  return RX_EMAIL.test(value.trim()) ? null : 'Enter a valid email address';
};

export const validateName = (value: string | undefined, label: string): string | null => {
  if (!value || value.trim() === '') {
    return `${label} is required`;
  }
  // Reject digits — names aren't numeric. Spaces, hyphens, and apostrophes remain allowed.
  if (/\d/.test(value)) {
    return `${label} can't contain numbers`;
  }
  // Must contain at least one letter (Unicode-aware, so accented/international names pass).
  if (!/\p{L}/u.test(value)) {
    return `Enter a valid ${label.toLowerCase()}`;
  }
  return null;
};

export const validatePhone = (value?: string): string | null => {
  if (!value || value.trim() === '') {
    return 'Phone number is required';
  }
  // Normalize to bare digits and drop an optional leading country code so formatting
  // variations — spaces, parens, dashes, a leading 1/+1 — match the same numbers the
  // view formats via getPhoneNumberDisplay. RX_PHONE then enforces NANP validity on the
  // bare 10 digits (and rejects extensions, which the view can't display).
  const digits = value.replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
  return RX_PHONE.test(digits) ? null : 'Enter a valid phone number';
};
